export default {
      id: "map__car_type_truck-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_truck",
      toString: function () {
        return this.url;
      }
    }